// Audio asset manifest — Parcel url: imports for all .webm assets

import bgm001 from 'url:../assets/bgm/001.webm';
import bgm002 from 'url:../assets/bgm/002.webm';
import bgm003 from 'url:../assets/bgm/003.webm';
import bgm004 from 'url:../assets/bgm/004.webm';
import bgm005 from 'url:../assets/bgm/005.webm';
import bgm006 from 'url:../assets/bgm/006.webm';
import bgm007 from 'url:../assets/bgm/007.webm';
import bgm008 from 'url:../assets/bgm/008.webm';
import bgm009 from 'url:../assets/bgm/009.webm';
import bgm010 from 'url:../assets/bgm/010.webm';

import sfxUiClick from 'url:../assets/sfx/ui/ui_click.webm';
import sfxUiPopupOpen from 'url:../assets/sfx/ui/ui_popup_open.webm';
import sfxUiPopupClose from 'url:../assets/sfx/ui/ui_popup_close.webm';
import sfxTilePlace from 'url:../assets/sfx/ui/tile_place.webm';
import sfxOverlayPlace from 'url:../assets/sfx/ui/overlay_place.webm';
import sfxOverlayUnlock from 'url:../assets/sfx/ui/overlay_unlock.webm';
import sfxRewardStar from 'url:../assets/sfx/ui/reward_star.webm';
import sfxResourceGain from 'url:../assets/sfx/ui/resource_gain.webm';
import sfxInvalidAction from 'url:../assets/sfx/ui/invalid_action.webm';

export const MUSIC_TRACKS = [
  { id: "001", url: bgm001 },
  { id: "002", url: bgm002 },
  { id: "003", url: bgm003 },
  { id: "004", url: bgm004 },
  { id: "005", url: bgm005 },
  { id: "006", url: bgm006 },
  { id: "007", url: bgm007 },
  { id: "008", url: bgm008 },
  { id: "009", url: bgm009 },
  { id: "010", url: bgm010 },
];

export const SFX_MAP = {
  ui_click:        [{ url: sfxUiClick }],
  ui_popup_open:   [{ url: sfxUiPopupOpen }],
  ui_popup_close:  [{ url: sfxUiPopupClose }],
  tile_place:      [{ url: sfxTilePlace }],
  overlay_place:   [{ url: sfxOverlayPlace }],
  overlay_unlock:  [{ url: sfxOverlayUnlock }],
  reward_star:     [{ url: sfxRewardStar }],
  resource_gain:   [{ url: sfxResourceGain }],
  invalid_action:  [{ url: sfxInvalidAction }],
};

export const SFX_COOLDOWNS = {
  ui_click: 40,
  resource_gain: 120,
  reward_star: 80,
  tile_place: 60,
  overlay_place: 60,
  invalid_action: 100,
};

export const SFX_MAX_POLYPHONY = {
  tile_place: 4,
  resource_gain: 2,
  reward_star: 3,
};
